module.exports = __webpack_public_path__ + "static/media/1.8d6c2bcd.gif";